import Config from '@/config'
import constant from '@/constant'

export { momentLocales } from './momentLocales'

const enData = `${Config.presenterDomain}/languages/AhaSlides_English.json`
const viData = `${Config.presenterDomain}/languages/AhaSlides_Vietnamese.json`
const esData = `${Config.presenterDomain}/languages/AhaSlides_Spanish.json`
const seData = `${Config.presenterDomain}/languages/AhaSlides_Swedish.json`
const ptData = `${Config.presenterDomain}/languages/AhaSlides_Portuguese.json`
const frData = `${Config.presenterDomain}/languages/AhaSlides_French.json`
const deData = `${Config.presenterDomain}/languages/AhaSlides_German.json`
const idData = `${Config.presenterDomain}/languages/AhaSlides_id.json`
const itData = `${Config.presenterDomain}/languages/AhaSlides_Italian.json`
const trData = `${Config.presenterDomain}/languages/AhaSlides_Turkish.json`
const csData = `${Config.presenterDomain}/languages/AhaSlides_Czech.json`
const krData = `${Config.presenterDomain}/languages/AhaSlides_Korean.json`
const noData = `${Config.presenterDomain}/languages/AhaSlides_Norwegian.json`
const jaData = `${Config.presenterDomain}/languages/AhaSlides_Japanese.json`
const nlData = `${Config.presenterDomain}/languages/AhaSlides_Dutch.json`
const ruData = `${Config.presenterDomain}/languages/AhaSlides_Russian.json`
const plData = `${Config.presenterDomain}/languages/AhaSlides_Polish.json`
const daData = `${Config.presenterDomain}/languages/AhaSlides_Danish.json`
const zhData = `${Config.presenterDomain}/languages/AhaSlides_Simplified_Chinese.json`
const slData = `${Config.presenterDomain}/languages/AhaSlides_Slovenia.json`
const siData = `${Config.presenterDomain}/languages/AhaSlides_Slovenia.json`
const skData = `${Config.presenterDomain}/languages/AhaSlides_Slovakia.json`
const lvData = `${Config.presenterDomain}/languages/AhaSlides_lv.json`
const elData = `${Config.presenterDomain}/languages/AhaSlides_Greek.json`
const ltData = `${Config.presenterDomain}/languages/AhaSlides_Lithuanian.json`
const hrData = `${Config.presenterDomain}/languages/AhaSlides_Croatian.json`
const isData = `${Config.presenterDomain}/languages/AhaSlides_Icelandic.json`
const bgData = `${Config.presenterDomain}/languages/AhaSlides_Bulgarian.json`
const roData = `${Config.presenterDomain}/languages/AhaSlides_Romanian.json`
const huData = `${Config.presenterDomain}/languages/AhaSlides_Hungary.json`
const sqData = `${Config.presenterDomain}/languages/AhaSlides_Albanian.json`

const messages = {
  en: enData,
  vi: viData,
  es: esData,
  pt: ptData,
  fr: frData,
  de: deData,
  id: idData,
  it: itData,
  tr: trData,
  ja: jaData,
  nl: nlData,
  ru: ruData,
  pl: plData,
  da: daData,
  zh: zhData,
  sl: slData,
  si: siData,
  lv: lvData,
  cs: csData,
  kr: krData,
  no: noData,
  se: seData,
  el: elData,
  lt: ltData,
  hr: hrData,
  is: isData,
  bg: bgData,
  ro: roData,
  sk: skData,
  hu: huData,
  sq: sqData,
}

const dataMessage = {}

export const getPresenterLanguageFromCdn = async (locale) => {
  if (dataMessage[locale]) {
    return dataMessage[locale]
  }
  let data = null
  try {
    if (locale === 'br') locale = 'pt'
    if (!messages[locale]) {
      locale = 'en'
    }
    data = await fetch(messages[locale]).then((r) => r.json())
    window.localStorage.setItem('aha-default-language', JSON.stringify(data))
    dataMessage[locale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}

export const getPresentingLanguageFromCdn = async (locale) => {
  if (dataMessage[locale]) {
    return dataMessage[locale]
  }
  let data = null
  try {
    if (locale === 'br') locale = 'pt'
    if (!messages[locale]) {
      locale = 'en'
    }
    data = await fetch(messages[locale]).then((r) => r.json())
    dataMessage[locale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}

export const getDefaultLanguageFallback = async () => {
  const defaultLanguageFallbackLocale = constant.defaultFallbackLocale
  if (dataMessage[defaultLanguageFallbackLocale]) {
    return dataMessage[defaultLanguageFallbackLocale]
  }
  let data = null
  try {
    data = await fetch(messages[defaultLanguageFallbackLocale]).then((r) => r.json())
    dataMessage[defaultLanguageFallbackLocale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}
